export enum SmartHomeProviderName {
    Notion = 'notion',
    Kangaroo = 'kangaroo',
    Frog = 'frog',
    SimpliSafe = 'simplisafe',
    ADT = 'adt',
    Ring = 'ring',
    RingFlo = 'ringflo'
}

export const providerToExperimentFlagMap: Record<SmartHomeProviderName, string> = {
    [SmartHomeProviderName.Ring]: 'HIP26712-Ring',
    [SmartHomeProviderName.RingFlo]: 'HIP26712-RingFlo',
    [SmartHomeProviderName.Notion]: 'HIP26712-Notion',
    [SmartHomeProviderName.Kangaroo]: 'HIP26712-Kangaroo',
    [SmartHomeProviderName.Frog]: 'HIP26712-Frog',
    [SmartHomeProviderName.SimpliSafe]: 'HIP26712-SimpliSafe',
    [SmartHomeProviderName.ADT]: 'HIP26712-ADT'
};
